var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "inp-subtle"
  }, [_c('span', {
    staticClass: "inp-subtle-span",
    domProps: {
      "textContent": _vm._s(_vm.value || _vm.placeholder)
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "inp-big-focus",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.model)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model = $event.target.value
      }
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b26b0ab0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputSubtle.vue
// module id = 56
// module chunks = 1